export default {
  GET_ITEMS(state) {
    return state.services
  },

  GET_ITEM(state, id) {
    return state.services.find(item => item.id == id)
  },
}
